import React from 'react'
import classnames from 'classnames'

import { isReadyToShipTagSupportedForProduct } from './utils'

import styles from './product-tags.module.scss'

const ReadyToShip = ({ shopifyProductId }: { shopifyProductId: number }) => {
  const shouldShowReadyToShipTag = isReadyToShipTagSupportedForProduct(shopifyProductId)
  return shouldShowReadyToShipTag ? (
    <li className={classnames(styles.tag)} key="readyToShip">
      Ready to Ship
    </li>
  ) : null
}

export { ReadyToShip }
